export enum TabButtonStatus {
    READY = 'Ready',
    COOKING = 'Cooking',
    ACCEPT = 'Accept',
    PENDING = 'Pending',
}